import React from 'react'
import Basicweb from '../components/basic-webdata'
import BasicWebDetail from '../components/basicWeb-detail'
import LeadBasicweb from '../components/Lead-basicweb'
import usePageMeta from '../hooks/usePageMeta';

export default function BasicWeb() {
    usePageMeta('Basic Website Design for eCommerce Brands | Spinnennetz', 'Get a professional and responsive basic web design for your growing business. Spinnennetz delivers fast, modern, and SEO-friendly websites optimized for growth.', '/basic-web', {"@context":"https://schema.org","@type":"Service","name":"Basic Website Design","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
        <BasicWebDetail/>
        <Basicweb/>
        <LeadBasicweb/>
        </>
    )
}
